import {Component, OnInit} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {OptionItem} from '@shared/models/option-item';

@Component({
    standalone: false,
    selector: 'app-upload-options-dialog',
  templateUrl: './upload-options-dialog.component.html',
  styleUrls: ['./upload-options-dialog.component.scss'],
})
export class UploadOptionsDialogComponent implements OnInit, IDialogView {
  errorMsg: string;
  data: DialogModel;
  option: OptionItem;
  options: OptionItem[] = [
    {
      id: 'replace-existing-file',
      text: 'Replace existing file',
      isCustom: true,
    },
    {
      id: 'keep-both-files',
      text: 'Keep both files',
      isCustom: true,
    },
  ];

  constructor() {
  }

  ngOnInit(): void {
    this.errorMsg = this.data.input.error;
    this.option = this.options[0];
  }

  onOkClicked(): any {
    if (this.option) {
      this.data.input.option = this.option;
      return true;
    }
    return false;
  }
}
